export default __webpack_public_path__ + "static/media/centos.3ca0e1b5.svg";